import React from 'react';
import {connect} from 'react-redux'
import {Route, Switch, withRouter} from 'react-router-dom'
import {push} from 'react-router-redux'
import {bindActionCreators} from 'redux'

import {clearAlert, clearState} from 'Skelet/src/modules/fetch.action.js'
import AlertBar from 'Skelet/src/components/AlertBar.js'
import PageNotFound from 'Skelet/src/components/PageNotFound.js'
import CoreRoute from './route-containers/CoreRoute.js'
import StartRoute from './route-containers/StartRoute.js'
import Start from './StartPages/Start.js'
import SolutionsNL from './StartPages/Solutions.js'
import BlogEN from './StartPages/Blog-EN.js'
import BlogNL from './StartPages/Blog.js'
import BlogPostNL from './StartPages/BlogPost.js'
import Roadmap from './StartPages/Roadmap.js'
import Milestones from './StartPages/Milestones.js'
import Pricing from './StartPages/Pricing.js'
import Privacy from './StartPages/Privacy.js'
import Terms from './StartPages/Terms.js'
import Poll from './Poll.js'
import Quickpoll from './Quickpoll.js'
import Quickpollmedia from './Quickpollmedia.js'
import Feedback from './Feedback.js'
import ArticleFeedback from './ArticleFeedback.js'
import Polls from './Polls.js'
import QuickPolls from './QuickPolls.js'
import QuickPollsMedia from './QuickPollsMedia.js'
import Settings from './Settings.js'
import AdminPolls from './AdminPolls.js' // @temp will be removed/replaced
import AdminAccounts from './AdminAccounts.js' // @temp will be removed/replaced


class App extends React.Component {

  componentDidUpdate(prevProps) {
    const isLoggingOut = prevProps.session_token && !this.props.session_token
    const isLoggingIn = !prevProps.session_token && this.props.session_token

    if (isLoggingIn) {
      if(this.props.redirectUrl) {
        this.props.push(this.props.redirectUrl);
      } else {
        this.props.push("/");
      }
    } else if (isLoggingOut) {
      this.props.clearState();
      this.props.push("/start");
    }
  }

  componentDidMount() {
    if(this.props.state_router.location.pathname === "/en" || this.props.state_router.location.pathname === "/en/") {
      this.props.push("/en/start");
    }
  }

  render() {
    return (
      <div id="main">
        <Switch>
          <StartRoute lang="EN" exact path="/en" component={Start} />
          <StartRoute lang="EN" exact path="/en/start" component={Start} />
          <StartRoute lang="NL" exact path="/start" component={Start} />
          <StartRoute lang="NL" exact path="/oplossingen" component={SolutionsNL} />
          <StartRoute lang="EN" exact path="/en/blog" component={BlogEN} />
          <StartRoute lang="NL" exact path="/blog" component={BlogNL} />
          <StartRoute lang="NL" exact path="/blog-post/*" component={BlogPostNL} />
          <StartRoute lang="EN" exact path="/en/roadmap" component={Roadmap} />
          <StartRoute lang="NL" exact path="/roadmap" component={Roadmap} />
          <StartRoute lang="EN" exact path="/en/milestones" component={Milestones} />
          <StartRoute lang="NL" exact path="/mijlpalen" component={Milestones} />
          <StartRoute lang="EN" exact path="/en/pricing" component={Pricing} />
          <StartRoute lang="NL" exact path="/prijzen" component={Pricing} />
          <StartRoute lang="EN" exact path="/privacy" component={Privacy} />
          <StartRoute lang="EN" exact path="/terms" component={Terms} />
          <Route exact path="/poll/:id" component={Poll} />
          <Route exact path="/quickpoll/:id" component={Quickpoll} />
          <Route exact path="/quickpollmedia/:id" component={Quickpollmedia} />
          <Route exact path="/feedback/:id" component={Feedback} />
          <Route exact path="/articlefeedback/:id" component={ArticleFeedback} />

          <CoreRoute exact path="/" component={Polls} />
          <CoreRoute exact path="/quickpolls" component={QuickPolls} />
          <CoreRoute exact path="/quickpolls-media" component={QuickPollsMedia} />
          <CoreRoute exact path="/settings" component={Settings} />
          <CoreRoute exact path="/dashboard/adminpolls" component={AdminPolls} />
          <CoreRoute exact path="/dashboard/adminaccounts" component={AdminAccounts} />

          <Route path="*" component={PageNotFound} />
        </Switch>
        <AlertBar alert={this.props.alert} clearAlert={this.props.clearAlert} />
      </div>
    );
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    state_router: state.router, // needed for redirect after login
    session_token: session_token,
    redirectUrl: state.apiData.redirectUrl,
    alert: state.apiData.alert,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    push,
    clearAlert,
    clearState,
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))



// WEBPACK FOOTER //
// ./src/containers/_app.js